export {GraphHumanumModule} from './core/graph-humanum.module';
export {GraphHumanumService} from './core/services/graph-humanum.service';